if (!customElements.get('results-custom-container')) {
  class ResultsCustomContainer extends HTMLElement {
    constructor() {
      super();
      this.styleType = this.dataset.style;
      this.duration = parseInt(this.dataset.duration, 10) || 650;
      this.initDelay = parseInt(this.dataset.delay, 10) || 0;
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            window.setTimeout(() => this.animateAll(), this.initDelay);
            this.observer.disconnect();
          });
        },
        { threshold: 0.3 }
      );
    }

    connectedCallback() {
      this.observer.observe(this);
    }

    animateAll() {
      const rows = this.querySelectorAll('.results__percentage');
      rows.forEach((row) => {
        const value = parseInt(row.dataset.percentage, 10) || 0;
        this.animateRow(row, value);
      });
    }

  animateRow(row, value) {
    const output = row.querySelector('p');
    const start = performance.now();
    const prefix = row.dataset.prefix || '';
    const suffix = Object.prototype.hasOwnProperty.call(row.dataset, 'suffix') ? row.dataset.suffix : '%';
    const formatThousands = row.dataset.format === 'thousands';

      if (this.styleType === 'circle') {
        const ring = row.querySelector('.ring__prog');
        if (ring) {
          requestAnimationFrame(() => {
            ring.setAttribute('stroke-dasharray', `${value} 100`);
          });
        }
      }

    const step = (time) => {
      const progress = Math.min((time - start) / this.duration, 1);
      const current = Math.round(progress * value);
      if (output) {
        const formatted = formatThousands
          ? new Intl.NumberFormat('fr-FR').format(current)
          : current;
        output.textContent = `${prefix}${formatted}${suffix}`;
      }
      if (progress < 1) requestAnimationFrame(step);
    };

      requestAnimationFrame(step);
    }
  }

  customElements.define('results-custom-container', ResultsCustomContainer);
}